import { useState } from 'react';
import Button from './Button';
import styles from './styles.module.scss';
import ReactGA from "react-ga4";

ReactGA.initialize("G-HYJDMRTYFP");
ReactGA.send({ hitType: "pageview", page: window.location.pathname });

const PasswordInput = (props) => {
    const [correct,setCorrect] = useState(0);

   const symbols = [
        '∞','¤','♦','⌂','╬','§','¥','Ω','Φ'
    ];
    const getChar = (e) => {
            const inp = document.querySelector('input');
        let elem = e.target.textContent;

        if(inp.value.length < 19){
            inp.value = inp.value + elem;
        }
    }

        function download(fileUrl, fileName, isGame) {
        var a = document.createElement("a");
        a.href = fileUrl;
        a.setAttribute("download", fileName);
        a.click();
           ReactGA.event(`${isGame ? 'Download': 'Secret Password:'} ${fileName}`, {
        'event_category': 'File',
        'event_label': `/downloadable/${fileName}`
      });
      }
    const checkPassword = () => {
            const inp = document.querySelector('input');
        let inbval = inp.value.toUpperCase();
console.log(inbval);
        if(correct == 0){

let passCorrect = false;
        switch(inbval){
            case 'ORIGINAL':
                passCorrect = true;
              if(props.xmas){
                download("downloadable/FNAP_KG_XMASS.ZIP", "FNAP_KG_XMASSs.ZIP",true);
              }else if (props.halloween){
                download("downloadable/PKG_HALLOWEEN.ZIP", "PKG_HALLOWEEN.ZIP",true);
              }else{
                download("downloadable/FNAP_KG.ZIP", "FNAP_KG.ZIP",true);
              }
         
              
            break;
            case 'STAY_AVVAY':
                 passCorrect = true;
                download("downloadable/StayAwayFromTheDark.txt", "StayAwayFromTheDark.txt",false);
               
              
            break;
            case 'Y||N|3$90U!':
                 passCorrect = true;
                download("downloadable/Yume Souls.ZIP", "Yume Souls.ZIP",true);
                localStorage.setItem('cardsOfHorror','true');
               
              
            break;
             case 'I<3V^P\\IX':
                 passCorrect = true;
                download("downloadable/yumeAddon.json", "yumeAddon.json",false);
               
              
            break;
            case 'FAAKBOAR':
                 passCorrect = true;
                download("downloadable/Save02.rvdata2", "Save02.rvdata2",false);
               
              
            break;
            case 'W_O_V.,.,.**':
                  passCorrect = true;
                download("downloadable/World_of_V.png", "World_of_V.png",false);
               
            break;
            case 'RUR!C()-01':
                  passCorrect = true;
                download("downloadable/ACKNOWLEDGE.png", "ACKNOWLEDGE.png",false);
               
              
            break;
            case 'M@N-3ATER':
                  passCorrect = true;
                download("downloadable/ZCP_File1.png", "ZCP_File1.png",false);
            
              
            break;
            case 'Y3CE:P:E:R':
                  passCorrect = true;
                download("downloadable/KRIPI.odt", "KRIPI.odt",false);
               
              
            break;
            case 'V_^_^SINA':
                  passCorrect = true;
                download("downloadable/V.GIF", "V.GIF",false);
                
            break;
            case 'G#LD$3N--P$99%':
                  passCorrect = true;
                download("downloadable/GPOOF.png", "GPOOF.png",false);
                
            break;
            case '$0LDI3R':
                  passCorrect = true;
                download("downloadable/FATE_POOF.png", "FATE_POOF.png",false);
             
            break;
            case 'C@RSK@RS':
                  passCorrect = true;
                download("downloadable/FATE_CAPCAKE.png", "FATE_CAPCAKE.png",false);
              
            break;
            case 'S!A^T*A-N':
                  passCorrect = true;
                download("downloadable/FATE_SONIA.png", "FATE_SONIA.png",false);
            
            break;
            case 'CUBUCUBUCUBU':
                  passCorrect = true;
                download("downloadable/FATE_CUBUS.png", "FATE_CUBUS.png",false);
             
            break;
            case 'T3A-ZZARD':
                  passCorrect = true;
                download("downloadable/FATE_TEALENA.png", "FATE_TEALENA.png",false);
               
            break;
            case 'ENGAGEALL':
                  passCorrect = true;
                download("downloadable/Save04.rvdata2", "Save04.rvdata2",false);
                
            break;
            case 'ENR@G3M3NT':
                  passCorrect = true;
                download("downloadable/Save05.rvdata2", "Save05.rvdata2",false);
              
            break;
            case '<3IS3IS3>':
                  passCorrect = true;
                download("downloadable/Save03.rvdata2", "Save03.rvdata2",false);
                
            break;
            case 'IY`$T0VR-F∞A¤U♦L⌂T╬':
                  passCorrect = true;
                download("downloadable/FI713.ZIP", "FI713.ZIP",true);
               

            break;
            case 'H¤RRΦR§AB¤V♦CO∞Ω':
                  passCorrect = true;
                download("downloadable/Kene&SabriniCardsOfHorror.ZIP", "Kene&SabriniCardsOfHorror.ZIP",true);
                localStorage.setItem('cardsOfHorror','true');
           

            break;
            case 'F3MALE⌂LI∞N':
                  passCorrect = true;
                download("downloadable/calimaria.mp4", "calimaria.mp4",false);
             

            break;
            case 'Z¤R¤ZZ¤':
                  passCorrect = true;
                download("downloadable/origin.mp4", "origin.mp4",false);
               

            break;
            case '♦POΩOR':
                  passCorrect = true;
                download("downloadable/poorCreatures.png", "poorCreatures.png",false);
      

            break;
            case 'EL§FANTOΦ':
                  passCorrect = true;
                download("downloadable/phanto.png", "phanto.png",false);
          

            break;
            case '╬╬BSCUSS':
                  passCorrect = true;
                download("downloadable/limetree.mp4", "limetree.mp4",false);
              

            break;
            case '§R¤FT':
                  passCorrect = true;
                download("downloadable/srj.png", "srj.png",false);
            

            break;
            case 'B3N3':
                  passCorrect = true;
                download("downloadable/b3n3.png", "b3n3.png",false);
         

            break;
            case 'SCAV¥':
                  passCorrect = true;
                download("downloadable/past.png", "past.png",false);
            

            break;
            case 'L¤¥§':
                  passCorrect = true;
                download("downloadable/chips.png", "chips.png",false);
     

            break;
            case 'N∞C':
                  passCorrect = true;
                download("downloadable/radiant.mp4", "radiant.mp4",false);
        

            break;
            case '3H♦♦♦♦':
                  passCorrect = true;
                download("downloadable/wov_comic.png", "wov_comic.png",false);
       

            break;
            case 'IPICKDIAXES':
                  passCorrect = true;
                download("downloadable/sriaxes.mp4", "sriaxes.mp4",false);
        

            break;
            case 'D╬§NEY':
                  passCorrect = true;
                download("downloadable/moice1.png", "moice1.png",false);
               

            break;
            case 'G╬M⌂ΩD':
                  passCorrect = true;
                download("downloadable/walt_memory.mp4", "walt_memory.mp4",false);
         

            break;
            case '╬⌂¤ΦΩ¥§♦∞':
                  passCorrect = true;
                download("downloadable/Vampirim.mp4", "Vampirim.mp4",false);
              

            break;
            case '§RΦΩ╬¤KREEPY':
                  passCorrect = true;
                download("downloadable/Blurred Face.ZIP", "Blurred Face.ZIP",true);
             

            break;

            case '♦⌂§¥¥ΩΩ':
                  passCorrect = true;
                download("downloadable/TBOP_KG.ZIP", "TBOP_KG.ZIP",true);
             

            break;

            case '♦♦♦∞♦♦♦':
                  passCorrect = true;
                download("downloadable/PKG_NT.ZIP", "PKG_NT.ZIP",true);
             

            break;

            case '∞¤♦╬§⌂⌂':
                  passCorrect = true;
                download("downloadable/addonDroplets.json", "addonDroplets.json",false);
             

            break;

            case '♦¤⌂♦¤∞§':
                  passCorrect = true;
                download("downloadable/addonRerattled.json", "addonRerattled.json",false);
            break;

            case '⌂╬§¥ΩΩ∞':
                  passCorrect = true;
                download("downloadable/addonCreepy.json", "addonCreepy.json",false);
            break;

            case '⌂╬╬§¥¥Ω':
                  passCorrect = true;
                download("downloadable/addonUnderworld.json", "addonUnderworld.json",false);
            break;

             case '∞♦♦¤¤¥§':
                  passCorrect = true;
                download("downloadable/addonWov.json", "addonWov.json",false);
            break;

            case '∞¤¤♦⌂╬§§':
                  passCorrect = true;
                download("downloadable/addonNextTime.json", "addonNextTime.json",false);
            break;

            case '§♦§∞¤╬ΦΦ':
                  passCorrect = true;
                download("downloadable/addonDivided.json", "addonDivided.json",false);
            break;

            case 'CR()NIIC':
                  passCorrect = true;
                download("downloadable/addonCronic.json", "addonCronic.json",false);
            break;

            case 'WI&S$EES':
                  passCorrect = true;
                download("downloadable/addonWishful.json", "addonWishful.json",false);
            break;

            case 'UIL<>A*':
                  passCorrect = true;
                download("downloadable/addonDebovcherry.json", "addonDebovcherry.json",false);
            break;

                   case 'LORE_IS_PAST':
                  passCorrect = true;
                download("downloadable/LoRp.png", "LoRp.png",false);
             

            break;
            case 'S33KD3P_$R':
                  passCorrect = true;
                download("downloadable/WhatsThat.ZIP", "WhatsThat.ZIP",true);
             

            break;
            default:
             setCorrect(2);
            break;
              
        }
        inp.value = '';
        if(passCorrect){
        setCorrect(1);
        }

        setTimeout(()=>{
        setCorrect(0);
        },1000);
        }

    }
    const divs = [];
    for(let i = 0; i < 9; i++){
        divs.push(  <div onClick={getChar} className={`${styles.passwordButton} ${styles.backgroundColorMedium} ${props.xmas && styles['backgroundColorMedium--xmas']} ${props.halloween && styles['backgroundColorMedium--halloween']}`}>{symbols[i]}</div>);
    }
    
    return (
        <div className={`${styles.inputArea}`} >
            <div className={`${styles.passwordMessage} ${correct == 1 && styles['passwordMessage--correct']} ${correct == 2 && styles['passwordMessage--incorrect']}`}>
                {correct == 1 && 'Correct Password'}   {correct == 2 && 'Incorrect Password'}
            </div>
            <input maxLength={19}/>
            <div className={`${styles.passwordGrid} ${styles.backgroundColorLight} ${props.xmas && styles['backgroundColorLight--xmas']} ${props.halloween && styles['backgroundColorLight--halloween']}`}>
            {divs}
            </div>
            <a onClick={checkPassword}><Button  size="large">Confirm</Button></a>
        </div>
    );
}


export default PasswordInput;